import React, { useEffect, useRef, useState } from "react";
import * as S from "./styles";
import data from "./eventsData";
import plus from "../../../assets/icons/plus.png";
import list from "../../../assets/icons/icon-to-do-blue.png";
import Tooltip from "../../tooltip";
import Modal from "../../../components/modal/modalGenericV2";
import {
  Auxiliar,
  BodyG,
  BodyM,
  Display,
  TaglineM,
  TaglineP,
} from "../../../styles/stylesTypography";
import { theme } from "../../../styles/theme";
import FunctionBlockedOverlay from "../../functionBlocked";

import { store } from "react-notifications-component";


import local from "../../../assets/icons/icon-pin-blue.png";
import whatsapp from "../../../assets/icons/icon-whatsapp-gray.png";
import IconSearchNotFound from "../../../assets/icons/icons8-search-notfound.png";
import email from "../../../assets/icons/icon-mail-gray.png";
import phone from "../../../assets/icons/icon-phone-gray.png";
import IconMap from "../../../assets/icons/icon-pin-gray.png";

import api from "../../../services/api";
import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
import RegisterAgronomist from "../../AddModals/RegisterAgronomist";
import RegisterFarm from "../../AddModals/RegisterFarm";
import ModalCreateOrEditEvent from "../../modalCreateOrEditEvent";
import RegisterProducer from "../../AddModals/RegisterProducer";
import SelectV2Multi from "../../select/select_v2_multi";
import CommentExample from "../../../components/CommentSection/CommentSection";

import ModalBlock from "../../../components/modal/modalFuncaoBloqueadaImpressaoFe";
import { openCulturaUrl } from "../../../utils/culturasPdf";

const { events, links } = data;

const CropManagement = ({ overlayMode = "self", agronomoId = null }) => {
  const isFunctionBlocked = (user) => {
  const planId = user?.contrato?.agro_plan_config?.agro_plan_id;
  const diasRestante = Number(user?.contrato?.dias_restante ?? 0);
  return (
    planId === 7 ||
    planId === 6 ||
    planId === 4 ||
    (planId === 1 && diasRestante <= 0)
  );
};

const getUserFromStorage = () => {
  try {
    return JSON.parse(localStorage.getItem("@userinfo"));
  } catch {
    return null;
  }
};

  const [events, setEvents] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [showNewEvent, setShowNewEvent] = useState(false);
  const [currentId, setCurrentId] = useState(0);

  const [titleDrawer, setTitleDrawer] = useState("");
  const [descriptionDrawer, setDescriptionDrawer] = useState("");
  const [agronomistDrawer, setAgronomistDrawer] = useState({
    value: null,
    label: "",
  });
  const [producerDrawer, setProducerDrawer] = useState({
    value: null,
    label: "",
  });
  const [cultureDrawer, setCultureDrawer] = useState({
    value: null,
    label: "",
  });
  const [startDateDrawer, setStartDateDrawer] = useState("");
  const [endDateDrawer, setEndDateDrawer] = useState("");
  const [statusDrawer, setStatusDrawer] = useState({ value: null, label: "" });

  const [agronomists, setAgronomists] = useState([]);
  const [producers, setProducers] = useState([]);
  const [agroFarmsDrawer, setAgroFarmsDrawer] = useState({
    value: null,
    label: "",
  });
  const [agroFarms, setAgroFarms] = useState([]);
  const [cultures, setCultures] = useState([]);

  const [isFarmDisabled, setIsFarmDisabled] = useState(true);
  const [isButtonFarmDisabled, setIsButtonFarmDisabled] = useState(true);

  // Estados para controle de erros
  const [titleError, setTitleError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [agronomistError, setAgronomistError] = useState(false);
  const [producerError, setProducerError] = useState(false);
  const [farmError, setFarmError] = useState(false);
  const [cultureError, setCultureError] = useState(false);
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [statusError, setStatusError] = useState(false);

  // Refs - Drawer
  const selectAgronomistRef = useRef(null);
  const selectProducerRef = useRef(null);
  const selectAgroFarmsRef = useRef(null);
  const selectCultureRef = useRef(null);
  const selectStatusRef = useRef(null);

  //Modal
  const [showAddAgronomist, setShowAddAgronomist] = useState(false);
  const [showAddProducer, setShowAddProducer] = useState(false);
  const [showAddFarm, setShowAddFarm] = useState(false);

  const [idProducer, setIdProducer] = useState(0);
  const [agroFarmIdToSelect, setAgroFarmIdToSelect] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [userCoords, setUserCoords] = useState(null);
  const [eventCoords, setEventCoords] = useState(null);

  const [openModalTrue, setOpenModalTrue] = useState(false);

  const getEvents = async () => {
    try {
      const endpoint = agronomoId
        ? `/agenda/resumo/responsavel/${agronomoId}`
        : "/agenda/resumo";
      const response = await api.get(endpoint);

      if (response) {
        const payload = response.data?.data ?? response.data ?? [];
        const reversedEvents = Array.isArray(payload)
          ? payload.slice().reverse()
          : [];

        setEvents(reversedEvents);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getEvents();
  }, []);

  const formatarData = (dataISO) => {
    const mesesAbreviados = [
      "JAN",
      "FEV",
      "MAR",
      "ABR",
      "MAI",
      "JUN",
      "JUL",
      "AGO",
      "SET",
      "OUT",
      "NOV",
      "DEZ",
    ];

    const data = new Date(dataISO);
    const dia = data.getUTCDate();
    const mes = mesesAbreviados[data.getUTCMonth()];
    const ano = data.getUTCFullYear();

    return `${dia} ${mes} ${ano}`;
  };

  const formatarDataParaAPI = (dataLocal) => {
    if (!dataLocal) return "";
    const date = new Date(dataLocal);

    const offset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - offset).toISOString();
  };

  const requestGeolocation = () => new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) {
      reject({ code: 'NOT_SUPPORTED' });
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => resolve({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy,
      }),
      (error) => reject(error),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  });

  const tryGetGeolocation = async () => {
    try {
      const coords = await requestGeolocation();
      return coords;
    } catch (err) {
      let message = null;
      if (err?.code === 1) message = identifyErrorMenssage(err, "Permissão de localização negada. O evento será criado sem coordenadas.");
      else if (err?.code === 2) message = identifyErrorMenssage(err, "Localização indisponível no momento. O evento será criado sem coordenadas.");
      else if (err?.code === 3) message = identifyErrorMenssage(err, "Tempo esgotado ao obter localização. O evento será criado sem coordenadas.");
      else if (err?.code === 'NOT_SUPPORTED') message = identifyErrorMenssage(err, "Geolocalização não suportada neste dispositivo/navegador.");
      if (message) {
        store.addNotification({
          title: "Atenção",
          message,
          type: "warning",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true },
        });
      }
      return null;
    }
  };

  const buildMeteoblueUrl = (lat, lng) => {
    if (lat == null || lng == null) return null;
    return `https://www.meteoblue.com/en/weather/maps/widget/${lat}N${lng}E654_America%2FSao_Paulo?windAnimation=1&gust=1&satellite=1&cloudsAndPrecipitation=1&temperature=1&sunshine=1&extremeForecastIndex=1&geoloc=fixed&tempunit=C&windunit=km%252Fh&lengthunit=metric&zoom=10&autowidth=auto`;
  };

  const requestGeolocationOnCreate = () => {
    tryGetGeolocation()
      .then((c) => {
        setUserCoords(c);
        if (c && c.latitude != null && c.longitude != null) {
          store.addNotification({
            title: "Localização registrada",
            message: `Coordenadas capturadas: ${typeof c.latitude === 'number' ? c.latitude.toFixed(6) : c.latitude}, ${typeof c.longitude === 'number' ? c.longitude.toFixed(6) : c.longitude}`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 4000, onScreen: true },
          });
        }
      })
      .catch(() => setUserCoords(null));
  };

  const handleLimparSelect = () => {
    if (selectAgronomistRef.current) {
      selectAgronomistRef.current.clearSelect();
    }

    if (selectProducerRef.current) {
      selectProducerRef.current.clearSelect();
    }

    if (selectAgroFarmsRef.current) {
      selectAgroFarmsRef.current.clearSelect();
    }

    if (selectCultureRef.current) {
      selectCultureRef.current.clearSelect();
    }

    if (selectStatusRef.current) {
      selectStatusRef.current.clearSelect();
    }
  };

  const clearFields = () => {
    handleLimparSelect();

    setTitleDrawer("");
    setDescriptionDrawer("");
    setResponsavelTecnicoSelecionado(agronomistPrefill || null);
    setProdutorSelecionado(null);
    setFazendaSelecionada(null);
    setCulturaSelecionada(null);

    setStartDateDrawer("");
    setEndDateDrawer("");
    setStatusDrawer({ value: 0, label: "" });
    setAgroFarmsDrawer({ value: 0, label: "" });
    setAgroFarms([]);
    setIsFarmDisabled(true);
    setIsButtonFarmDisabled(true);

    // Resetar erros
    setTitleError(false);
    setDescriptionError(false);
    setAgronomistError(false);
    setProducerError(false);
    setFarmError(false);
    setCultureError(false);
    setStartDateError(false);
    setEndDateError(false);
    setStatusError(false);

    setIsButtonFarmDisabled(true);
  };

  const formatCPF = (value) => {
    if (!value) return "";

    value = value.replace(/\D/g, "");

    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return value;
  };

  const formatCNPJ = (value) => {
    if (!value) return "";

    value = value.replace(/\D/g, "");

    value = value.replace(/(\d{2})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return value;
  };

  const formatCPFOrCNPJ = (value) => {
    const cleaned = value.replace(/\D/g, "");
    return cleaned.length <= 11 ? formatCPF(value) : formatCNPJ(value);
  };

  const getStatusLabel = (statusId) => {
    const statusMap = {
      1: "Não iniciado",
      2: "Em progresso",
      3: "Aguardando aprovação",
      4: "Pausado",
      5: "Atrasado",
      6: "Cancelado",
      7: "Feito",
    };
    return statusMap[statusId] || "";
  };

  const getAllProducers = async () => {
    const payload = {
      search: "",
      estado: "",
      order_by: { field: "modified", order: "DESC" },
    };

    try {
      const response = await api.post(
        "/produtores/pesquisa?limit=30&offset=0",
        payload
      );

      const produtores = response.data.data.produtores;

      const producersData = produtores.map((producer) => ({
        value: producer.id,
        label: producer.nome + " - " + formatCPFOrCNPJ(producer.cpf_cnpj),
        agro_farms: producer.agro_farms.map((farm) => ({
          id: farm.id,
          label: farm.nome,
          state: farm.estado,
        })),
      }));

      setProducers(producersData);

      if (producersData.length === 1) {
        const unico = producersData[0];
        setProducerDrawer({ value: unico.value, label: unico.label });
        setProducerError(false);
        // getAgroFarms(unico.value);
      }
    } catch (error) {
      console.error("Erro ao buscar produtores:", error);
    }
  };

  const getAgroFarms = async (producerId) => {
    if (!producerId) return;

    try {
      const response = await api.get(`/produtores/${producerId}/fazendas`);
      const agroFarmsData = response.data.data.map((agroFarm) => ({
        value: agroFarm.id,
        label: agroFarm.nome,
      }));

      setFazendaSelecionada(null)
      setAgroFarms(agroFarmsData);
      setIsFarmDisabled(false);
      setIsButtonFarmDisabled(false);

      if (agroFarmsData.length === 1) {
        const selectedFarm = {
          value: agroFarmsData[0].value,
          label: agroFarmsData[0].label,
        };

        setAgroFarmsDrawer(selectedFarm);
        setFarmError(false);

        setTimeout(() => {
          if (selectAgroFarmsRef.current) {
            const selectElement = selectAgroFarmsRef.current;

            if (typeof selectElement.handleChange === "function") {
              selectElement.handleChange({
                target: { value: String(selectedFarm.value) },
              });
            }
          }
        }, 100);
      }
    } catch (error) {
      setFazendaSelecionada(null)
      setIsFarmDisabled(true);
      setIsButtonFarmDisabled(false);

      setFarmError(true);

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, "ERRO-585 Nenhuma fazenda foi encontrada para esse produtor - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    }
  };

  const getAgronomists = async () => {
    const payload = {
      search: "",
      estado: "",
    };

    try {
      const response = await api.post(
        "/agronomos/pesquisa?limit=30&offset=0",
        payload
      );

      const agronomistsData = response.data.data.agronomists.map(
        (agronomist) => ({
          value: agronomist.id,
          label: agronomist.nome,
        })
      );

      setAgronomists(agronomistsData);

      if (agronomistsData.length === 1) {
        setAgronomistDrawer({
          value: agronomistsData[0].value,
          label: agronomistsData[0].label,
        });
        setAgronomistError(false);
      }
    } catch (error) {}
  };

  const getCultures = async () => {
    try {
      const response = await api.get("/culturas");

      const allCultures = response.data.data.flat();

      const culturesData = allCultures.map((culture) => ({
        value: culture.id,
        label: culture.nome_comum,
      }));

      setCultures(culturesData);

      if (culturesData.length === 1) {
        setCultureDrawer({
          value: culturesData[0].value,
          label: culturesData[0].label,
        });
        setCultureError(false);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (agroFarms.length > 0 && agroFarmIdToSelect) {
      const farm = agroFarms.find((f) => f.value === agroFarmIdToSelect);
      setFazendaSelecionada({
        value: agroFarmIdToSelect,
        label: farm?.label || "",
      });
    }
  }, [agroFarms, agroFarmIdToSelect]);

  useEffect(() => {
    if (showNewEvent && !eventCoords && !userCoords) {
      tryGetGeolocation()
        .then((c) => setUserCoords(c))
        .catch(() => {});
    }
  }, [showNewEvent, eventCoords, userCoords]);

  const validateForm = () => {
    let isValid = true;

    // Resetar todos os erros
    setTitleError(false);
    setDescriptionError(false);
    setAgronomistError(false);
    setProducerError(false);
    setFarmError(false);
    setCultureError(false);
    setStartDateError(false);
    setEndDateError(false);
    setStatusError(false);

    if (!titleDrawer.trim()) {
      setTitleError(true);
      isValid = false;
    }

    if (!responsavelTecnicoSelecionado || !responsavelTecnicoSelecionado.value) {
      setAgronomistError(true);
      isValid = false;
    }

    if (!startDateDrawer) {
      setStartDateError(true);
      isValid = false;
    }

    if (!endDateDrawer) {
      setEndDateError(true);
      isValid = false;
    }

    if (!statusDrawer.value) {
      setStatusError(true);
      isValid = false;
    }

    if (endDateDrawer < startDateDrawer) {
      setStartDateError(true);
      setEndDateError(true);

      store.addNotification({
        title: "Erro!",
        message: "A data final deve ser maior que a data inicial!",
        type: "warning",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });

      isValid = false;
    }

    return isValid;
  };

  const handleEditEvent = async () => {
    if (!validateForm()) {
      store.addNotification({
        title: "Atenção!",
        message: "Preencha todos os campos",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }

    setIsLoading(true);

    const payload = {
      title: titleDrawer,
      agro_agronomist_id: parseInt(responsavelTecnicoSelecionado.value),
      agro_producer_id: produtorSelecionado?.value ? parseInt(produtorSelecionado.value) : null,
      agro_farm_id: fazendaSelecionada?.value ? parseInt(fazendaSelecionada.value) : null,
      description: descriptionDrawer,
      agro_culture_id: culturaSelecionada?.value ? parseInt(culturaSelecionada.value) : null,
      date_begin: formatarDataParaAPI(startDateDrawer),
      date_end: formatarDataParaAPI(endDateDrawer),
      agro_task_status_id: parseInt(statusDrawer.value),
    };

    try {
      const response = await api.put(`/agenda/${currentId}`, payload);

      if (response) {
        setShowNewEvent(false);
        setIsEdit(false);
        clearFields();

        getEvents();

        store.addNotification({
          title: "Sucesso!",
          message: `${response.data.message}`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true },
        });
      }
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, "ERRO-586 Erro ao salvar evento - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveEvent = async () => {
    if (!validateForm()) {
      store.addNotification({
        title: "Erro!",
        message: "Preencha todos os campos obrigatórios",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }

    setIsLoading(true);

    let coords = userCoords;
    let capturedNow = false;
    if (!coords) {
      coords = await tryGetGeolocation();
      if (coords) { setUserCoords(coords); capturedNow = true; }
    }
    if (capturedNow && coords && coords.latitude != null && coords.longitude != null) {
      store.addNotification({
        title: "Localização registrada",
        message: `Coordenadas capturadas: ${typeof coords.latitude === 'number' ? coords.latitude.toFixed(6) : coords.latitude}, ${typeof coords.longitude === 'number' ? coords.longitude.toFixed(6) : coords.longitude}`,
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    }

    const payload = {
      title: titleDrawer,
      agro_agronomist_id: parseInt(responsavelTecnicoSelecionado.value),
      agro_producer_id: produtorSelecionado?.value ? parseInt(produtorSelecionado.value) : null,
      agro_farm_id: fazendaSelecionada?.value ? parseInt(fazendaSelecionada.value) : null,
      description: descriptionDrawer,
      agro_culture_id: culturaSelecionada?.value ? parseInt(culturaSelecionada.value) : null,
      date_begin: formatarDataParaAPI(startDateDrawer),
      date_end: formatarDataParaAPI(endDateDrawer),
      agro_task_status_id: parseInt(statusDrawer.value),
      ...(coords && coords.latitude != null && coords.longitude != null ? { latitude: String(coords.latitude), longitude: String(coords.longitude) } : {}),
    };

    try {
      const response = await api.post("/agenda", payload);

      if (response) {
        setShowNewEvent(false);
        setIsEdit(false);
        clearFields();

        getEvents();

        store.addNotification({
          title: "Sucesso!",
          message: `${response.data.message}`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true },
        });
        if (coords && coords.latitude != null && coords.longitude != null) {
          store.addNotification({
            title: "Localização registrada",
            message: `Coordenadas salvas no evento: ${String(coords.latitude)}, ${String(coords.longitude)}`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 4000, onScreen: true },
          });
        } else {
          store.addNotification({
            title: "Aviso",
            message: "Evento criado sem geolocalização.",
            type: "info",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 4000, onScreen: true },
          });
        }
      }
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, "ERRO-587 Erro ao salvar evento - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAgronomists();
    getCultures();
    getAllProducers();
  }, []);

  useEffect(() => {
    if (producerDrawer?.value) {
      getAgroFarms(producerDrawer.value);
    }
  }, [producerDrawer?.value]);

  const isToday = (date) => {
    const today = new Date();
    const eventDate = new Date(date);

    return (
      today.getDate() === eventDate.getDate() &&
      today.getMonth() === eventDate.getMonth() &&
      today.getFullYear() === eventDate.getFullYear()
    );
  };

  const containerRef = useRef();
  const blockedRef = useRef(null);
  const isBlocked = isFunctionBlocked(getUserFromStorage());

  const isMobileDevice = () => /android|iphone|ipad|ipod|windows phone/i.test((navigator.userAgent || "").toLowerCase());

  const getMapLink = (event) => {
    const farm = event.agro_farms || {};
    const hasCoords =
      farm.latitude != null &&
      farm.longitude != null &&
      farm.latitude !== "" &&
      farm.longitude !== "";
    const hasAddress = !!farm.endereco;

    if (!hasCoords && !hasAddress) return { href: null, disabled: true };

    const q = hasCoords
      ? `${farm.latitude},${farm.longitude}`
      : [
          farm.endereco,
          farm.numero,
          farm.bairro,
          farm.cidade,
          farm.estado,
          farm.cep,
        ]
          .filter(Boolean)
          .join(", ");

    const href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      q
    )}`;

    return { href, disabled: false };
  };
  
  const formatPhoneDigits = (phone) => {
    if (phone == null) return "";
    return String(phone).replace(/\D/g, "");
  };

  const formatPhoneDisplay = (phone) => {
    const digits = formatPhoneDigits(phone);
    if (!digits) return "";

    const localDigits =
      digits.length > 11 && digits.startsWith("55") ? digits.slice(2) : digits;

    if (localDigits.length === 11) {
      return `${localDigits.slice(0, 2)} ${localDigits.slice(
        2,
        7
      )}-${localDigits.slice(7)}`;
    }

    if (localDigits.length === 10) {
      return `${localDigits.slice(0, 2)} ${localDigits.slice(
        2,
        6
      )}-${localDigits.slice(6)}`;
    }

    return localDigits;
  };

  const getTelHref = (phone) => {
    const digits = formatPhoneDigits(phone);
    if (!digits) return null;
    const withCountry = digits.startsWith("55") ? digits : `55${digits}`;
    return `tel:+${withCountry}`;
  };

  const getWhatsAppHref = (phone) => {
    const digits = formatPhoneDigits(phone);
    if (!digits) return null;
    const withCountry = digits.startsWith("55") ? digits : `55${digits}`;
    return `https://wa.me/${withCountry}`;
  };

  const copyTextToClipboard = async (text) => {
    if (!text) return false;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (error) {}

    try {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.top = "-9999px";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(textarea);
      return ok;
    } catch (error) {
      return false;
    }
  };

  const notifyPhoneCopied = () => {
    store.addNotification({
      title: "Sucesso!",
      message: "O telefone foi copiado com sucesso.",
      type: "success",
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 4000, onScreen: true },
    });
  };

  const goToCalendary = async (item) => {
    try {
      const response = await api.get(`/agenda/${item.id}`);

      setCurrentId(item.id);
      setIsEdit(true);
      setShowNewEvent(true);

      const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().slice(0, 16);
      };

      setTitleDrawer(response.data.title || "");
      setDescriptionDrawer(response.data.description || "");
      setStartDateDrawer(formatDateForInput(response.data.date_begin));
      setEndDateDrawer(formatDateForInput(response.data.date_end));

      if (response.data.agro_agronomist_id) {
        try {
          const responseAgronomist = await api.get(
            `/agronomos/${response.data.agro_agronomist_id}`
          );
          const agronomist = responseAgronomist.data.data;

          setResponsavelTecnicoSelecionado({
            value: agronomist.id,
            label: agronomist.nome,
          });
        } catch (error) {}
      }

      const producer = producers.find(
        (p) => p.value === response.data.agro_producer_id
      );
      setProdutorSelecionado({
        value: response.data.agro_producer_id,
        label: producer?.label || "",
      });

      await getAgroFarms(response.data.agro_producer_id);
      setAgroFarmIdToSelect(response.data.agro_farm_id);

      const culture = cultures.find(
        (c) => c.value === response.data.agro_culture_id
      );
      setCulturaSelecionada({
        value: response.data.agro_culture_id,
        label: culture?.label || "",
      });

      setStatusDrawer({
        value: response.data.agro_task_status_id,
        label: getStatusLabel(response.data.agro_task_status_id),
      });
      
      const latCandidate =
        response.data?.latitude ??
        response.data?.lat ??
        response.data?.event_latitude ??
        response.data?.local_latitude ??
        response.data?.agro_farms?.latitude;
      const lngCandidate =
        response.data?.longitude ??
        response.data?.lng ??
        response.data?.event_longitude ??
        response.data?.local_longitude ??
        response.data?.agro_farms?.longitude;

      if (latCandidate != null && latCandidate !== '' && lngCandidate != null && lngCandidate !== '') {
        const lat = typeof latCandidate === 'string' ? (parseFloat(latCandidate) ?? latCandidate) : latCandidate;
        const lng = typeof lngCandidate === 'string' ? (parseFloat(lngCandidate) ?? lngCandidate) : lngCandidate;
        const coords = { latitude: lat, longitude: lng };
        setEventCoords(coords);
        if (!userCoords) setUserCoords(coords);
      } else {
        setEventCoords(null);
      }
    } catch (error) {}
  };

  const deleteEvent = async () => {
      try {
        const response = await api.delete(`/agenda/${currentId}`);
  
        if (response) {
          setShowNewEvent(false);
          setIsEdit(false);
  
          store.addNotification({
            title: "Sucesso!",
            message: `${response.data.message}`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 4000,
              onScreen: true,
            },
          });
  
          getEvents();
          clearFields();
        }
      } catch (error) {
        store.addNotification({
          title: "Erro!",
          message: identifyErrorMenssage(error, "ERRO-588 Erro ao excluir o evento - Tente novamente, se o erro persistir acione o suporte."),
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true,
          },
        });
      }
    };

  const isCreateEventBlocked = () => {
    const user = getUserFromStorage();
    const planId = user?.contrato?.agro_plan_config?.agro_plan_id;
    const diasRestante = Number(user?.contrato?.dias_restante ?? 0);
    // 5 = plano com Caderno de Campo nativo; 9/10/11 = Protheus/SIAC/Omie
    // (integrações TOTVS/Omie) - também liberados pra criar evento.
    const planosComCadernoCampo = [5, 9, 10, 11];

    return !planosComCadernoCampo.includes(planId) || (planId === 1 && diasRestante > 0);
  };

  const handleCreateEventClick = () => {
    if (isCreateEventBlocked()) {
      setOpenModalTrue(true);
      return;
    }

    clearFields();
    setIsEdit(false);
    setCurrentId(null);
    setShowNewEvent(true);
    requestGeolocationOnCreate();
  };

  const [responsavelTecnicoSelecionado, setResponsavelTecnicoSelecionado] = useState(null);
  const [agronomistPrefill, setAgronomistPrefill] = useState(null);
  const [produtorSelecionado, setProdutorSelecionado] = useState(null);
  const [fazendaSelecionada, setFazendaSelecionada] = useState(null);
  const [culturaSelecionada, setCulturaSelecionada] = useState(null);

  useEffect(() => {
    const id = Number(agronomoId);
    if (!id) {
      setAgronomistPrefill(null);
      return;
    }

    let isActive = true;

    const loadAgronomist = async () => {
      try {
        const response = await api.get(`/agronomos/${id}`);
        const nome = response.data?.data?.nome || "";
        const option = { value: id, label: nome || String(id) };

        if (!isActive) return;

        setAgronomistPrefill(option);
        setAgronomists((prev) => {
          const list = Array.isArray(prev) ? prev : [];
          if (list.some((a) => Number(a.value) === id)) return list;
          return [option, ...list];
        });
        setResponsavelTecnicoSelecionado((current) => current || option);
      } catch (error) {
        if (!isActive) return;

        const option = { value: id, label: String(id) };
        setAgronomistPrefill(option);
        setAgronomists((prev) => {
          const list = Array.isArray(prev) ? prev : [];
          if (list.some((a) => Number(a.value) === id)) return list;
          return [option, ...list];
        });
        setResponsavelTecnicoSelecionado((current) => current || option);
      }
    };

    loadAgronomist();

    return () => {
      isActive = false;
    };
  }, [agronomoId]);

  return (
    <S.Container className="cropManagement" ref={blockedRef}>
      <S.Header>
        <BodyG color={theme.colors.gray.Cinza_2} fontWeight={700}>
          Caderno de campo
        </BodyG>

        <S.ViewAll as="a" href="/caderno-campo">
          <img src={list} alt="Lista" />

          <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>
            VER TODOS
          </TaglineM>
        </S.ViewAll>
      </S.Header>

      <S.CardsScroll>
      {events.map((event) => {
        const phoneRaw = event.agro_producers?.telefone;
        const phoneDisplay = formatPhoneDisplay(phoneRaw);
        const telHref = getTelHref(phoneRaw);
        const whatsappHref = getWhatsAppHref(phoneRaw);
        const farmLocation =
          (event.agro_farms?.latitude && event.agro_farms?.longitude) ||
          event.agro_farms?.endereco ||
          "";

        return (
        <S.EventCard
          key={event.id}
          onClick={() => goToCalendary(event)}
          ref={containerRef}
        >
          <div style={{ width: "100%", height: "auto", gap: "0.3rem", display: "flex", flexDirection: "column" }}>
            <S.EventTitle>
              <BodyM color={theme.colors.gray.Cinza_2} fontWeight={700}>
                {event.title}
              </BodyM>
            </S.EventTitle>

            <div style={{ width: "100%", height: "auto", display: "flex", justifyContent: "space-between"}}>
              <S.EventInfo>
                {event.agro_farms?.nome && (
                  <S.EventLocation>
                    <img src={local} alt="Ícone de localização" style={{ width: "16px", height: "16px" }} />

                    <TaglineP color={theme.colors.blue.Azul_link} fontWeight={800}>
                      {event.agro_farms?.nome}
                    </TaglineP>
                  </S.EventLocation>
                )}

                <TaglineP color={isToday(event.date_begin) ? `${theme.colors.orange.Laranja}` : theme.colors.gray.Cinza_7}>
                  {formatarData(event.date_begin)}
                </TaglineP>
              </S.EventInfo>

              <S.EventActions>
                {event.agro_cultures?.nome_comum && (
                  <S.CultureCircle
                    style={{ cursor: "pointer" }}
                    onClick={(e) => { e.stopPropagation(); openCulturaUrl(event.agro_cultures.nome_comum, event.agro_cultures.nome_cientifico); }}
                  >
                    <TaglineP color={theme.colors.white.Branco} fontWeight={800}>
                      {event.agro_cultures?.nome_comum}
                    </TaglineP>
                  </S.CultureCircle>
                )}

                <S.FarmWrapper>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <S.AnchorWrapper disabled={!telHref}>
                      {telHref ? (
                        <Tooltip
                          content={`Telefone: ${phoneDisplay}`}
                          placement="top"
                          animation="fade"
                          delay={[0, 100]}
                          arrow
                        >
                          <S.AnchorIcons
                            className="contact-icon"
                            href={telHref}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={async (e) => {
                              e.stopPropagation();

                              if (!isMobileDevice()) {
                                e.preventDefault();
                                const ok = await copyTextToClipboard(
                                  phoneDisplay || formatPhoneDigits(phoneRaw)
                                );
                                if (ok) notifyPhoneCopied();
                              }
                            }}
                            disabled={!telHref}
                          >
                            <img src={phone} alt="Ícone de telefone" style={{ width: "16px", height: "16px" }} />
                          </S.AnchorIcons>
                        </Tooltip>
                      ) : (
                        null
                      )}
                    </S.AnchorWrapper>

                    <S.AnchorWrapper disabled={!whatsappHref}>
                      {whatsappHref ? (
                        <Tooltip
                          content={`WhatsApp: ${phoneDisplay}`}
                          placement="top"
                          animation="fade"
                          delay={[0, 100]}
                          arrow
                        >
                          <S.AnchorIcons
                            className="contact-icon"
                            href={whatsappHref}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                            disabled={!whatsappHref}
                          >
                            <img src={whatsapp} alt="Ícone de WhatsApp" style={{ width: "16px", height: "16px" }} />
                          </S.AnchorIcons>
                        </Tooltip>
                      ) : (
                        null
                      )}
                    </S.AnchorWrapper>

                    <S.AnchorWrapper disabled={!farmLocation}>
                      {farmLocation
                        ? (() => {
                            const { href, disabled } = getMapLink(event);
                            const mapIcon = (
                              <a
                                href={href || undefined}
                                target={href ? "_blank" : undefined}
                                rel={href ? "noopener noreferrer" : undefined}
                                style={{
                                  cursor: disabled ? "not-allowed" : "pointer",
                                  opacity: disabled ? 0.5 : 1,
                                  marginRight: "0.75rem",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (disabled || !href) e.preventDefault();
                                }}
                              >
                                <img
                                  src={IconMap}
                                  alt="Abrir no mapa"
                                  style={{
                                    filter: "brightness(0) saturate(100%)",
                                    width: "16px",
                                    height: "16px",
                                  }}
                                />
                              </a>
                            );

                            if (disabled) return mapIcon;

                            return (
                              <Tooltip
                                content="Abrir no mapa"
                                placement="top"
                                animation="fade"
                                delay={[0, 100]}
                                arrow
                              >
                                {mapIcon}
                              </Tooltip>
                            );
                          })()
                        : null}
                    </S.AnchorWrapper>

                    {event.agro_producers?.nome && (
                      <S.ProfileCircle>
                        <Auxiliar
                          color={theme.colors.white.Branco}
                          fontWeight={700}
                        >
                          {event.agro_producers?.nome.slice(0, 2).toUpperCase()}
                        </Auxiliar>
                      </S.ProfileCircle>
                    )}
                  </div>
                </S.FarmWrapper>
              </S.EventActions>
            </div>
          </div>
        </S.EventCard>
        );
      })}

      </S.CardsScroll>

      {events.length === 0 && (
        <S.NotFound>
          <img src={IconSearchNotFound} alt="Ícone de pesquisa" />

          <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
              Nenhum evento encontrado
          </TaglineM>
        </S.NotFound>
      )}

      <div style={{ position: "sticky", bottom: 0 }}>
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "5rem",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            bottom: "-17px",
            backgroundColor: "#F8F8F9",
            color: "#F8F8F9",
          }}
        >
          {/* background para o botão de criar evento */}
        </div>
        <S.CreateEventButton onClick={() => {handleCreateEventClick()}}>
          <S.PlusIcon src={plus} />

          <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>
            CRIAR EVENTO
          </TaglineM>
        </S.CreateEventButton>
      </div>

      <ModalCreateOrEditEvent
        open={showNewEvent}
        onOpenChange={(e) => {
          setShowNewEvent(e);
          if (!e) {
            clearFields();
            setIsEdit(false);
          }
        }}
        isEdit={isEdit}
        onDelete={() => {
          deleteEvent();
        }}
        styles={S}
        responsavelTecnicoValue={responsavelTecnicoSelecionado ? responsavelTecnicoSelecionado.value : ""}
        onResponsavelTecnicoChange={(selectedOption) => {
          setResponsavelTecnicoSelecionado(selectedOption);
          setAgronomistError(false);
        }}
        agronomists={agronomists}
        agronomistError={agronomistError}
        onAddAgronomist={() => setShowAddAgronomist(true)}
        produtorValue={produtorSelecionado ? produtorSelecionado.value : ""}
        onProdutorChange={(selectedOption) => {
          setProdutorSelecionado(selectedOption);
          getAgroFarms(selectedOption.value);
          setIdProducer(selectedOption.value);
          if (!selectedOption.value) {
            setFazendaSelecionada(null);
          }
          setProducerError(false);
        }}
        producers={producers}
        producerError={producerError}
        onAddProducer={() => setShowAddProducer(true)}
        fazendaValue={fazendaSelecionada ? fazendaSelecionada.value : ""}
        onFazendaChange={(selectedOption) => {
          setFazendaSelecionada(selectedOption);
          setFarmError(false);
        }}
        agroFarms={agroFarms}
        farmError={farmError}
        isFarmDisabled={isFarmDisabled}
        isButtonFarmDisabled={isButtonFarmDisabled}
        onAddFarm={() => setShowAddFarm(true)}
        titleValue={titleDrawer}
        onTitleChange={(e) => {
          setTitleDrawer(e.target.value);
          if (e.target.value.trim()) setTitleError(false);
        }}
        titleError={titleError}
        descriptionValue={descriptionDrawer}
        onDescriptionChange={(e) => {
          setDescriptionDrawer(e.target.value);
          if (e.target.value.trim()) setDescriptionError(false);
        }}
        descriptionError={descriptionError}
        culturaValue={culturaSelecionada ? culturaSelecionada.value : ""}
        onCulturaChange={(selectedOption) => {
          setCulturaSelecionada({
            value: selectedOption.value,
            label: selectedOption.label,
          });
          setCultureError(false);
        }}
        cultures={cultures}
        cultureError={cultureError}
        startDateValue={startDateDrawer}
        onStartDateChange={(e) => {
          setStartDateDrawer(e.target.value);
          if (e.target.value) setStartDateError(false);
        }}
        startDateError={startDateError}
        endDateValue={endDateDrawer}
        onEndDateChange={(e) => {
          setEndDateDrawer(e.target.value);
          if (e.target.value) setEndDateError(false);
        }}
        endDateError={endDateError}
        statusRef={selectStatusRef}
        statusValue={statusDrawer.value ? statusDrawer : null}
        onStatusChange={(selectedOption) => {
          setStatusDrawer({
            value: selectedOption.value,
            label: selectedOption.label,
          });
          setStatusError(false);
        }}
        statusError={statusError}
        statusFloatingValue={statusDrawer.label}
        mapCoords={eventCoords}
        buildMapUrl={buildMeteoblueUrl}
        commentResourceId={isEdit ? currentId : 0}
        onSave={isEdit ? handleEditEvent : handleSaveEvent}
        isLoading={isLoading}
      />

      {showAddAgronomist && (
        <Modal
          show={showAddAgronomist}
          title="Cadastrar novo responsável técnico"
          onHide={() => setShowAddAgronomist(false)}
        >
          <RegisterAgronomist
            onSuccess={() => {
              getAgronomists();
              setShowAddAgronomist(false);
            }}
            onCancel={() => setShowAddAgronomist(false)}
          />
        </Modal>
      )}

      {showAddProducer && (
        <Modal
          show={showAddProducer}
          title="Cadastrar novo produtor"
          onHide={() => setShowAddProducer(false)}
        >
          <RegisterProducer
            onSuccess={() => {
              getAllProducers();
              setShowAddProducer(false);
            }}
            onCancel={() => setShowAddProducer(false)}
          />
        </Modal>
      )}

      {showAddFarm && (
        <Modal
          show={showAddFarm}
          title="Cadastrar nova fazenda"
          onHide={() => setShowAddFarm(false)}
        >
          <RegisterFarm
            producerId={idProducer}
            onSuccess={() => {
              getAgroFarms(idProducer);
              setShowAddFarm(false);
            }}
            onCancel={() => setShowAddFarm(false)}
          />
        </Modal>
      )}

      {overlayMode !== "none" && isBlocked && (
        <FunctionBlockedOverlay
          visible
          mode="cover-parent"
          attachTo={blockedRef}
          onActivate={() => {}}
        />
      )}

      {openModalTrue ? (
        <ModalBlock show={openModalTrue} onHide={() => setOpenModalTrue(false)} />
      ) : null}
    </S.Container>
  );
};
export default CropManagement;
